import { IOption } from 'libs/shared/ui/src/lib/components/dropdown/dropdown.component';
import {
  DifferenceReference,
  DifferencesSelection,
} from './model-forecast-differences-selection.types';

export const DIFFERENCE_REFERENCES: readonly DifferenceReference[] = [
  'TwelveHoursAgo',
  'TwentyFourHoursAgo',
  'PriorTradingDay00Z',
  'PriorTradingDay06Z',
  'PriorTradingDay12Z',
  'PriorTradingDay18Z',
];

export const DIFFERENCE_REFERENCE_OPTIONS: IOption[] = [
  { labelKey: 'differenceRefTwelveHoursAgo', value: 'TwelveHoursAgo' },
  {
    labelKey: 'differenceRefTwentyFourHoursAgo',
    value: 'TwentyFourHoursAgo',
  },
  { labelKey: 'differenceRefPriorTradingDay00Z', value: 'PriorTradingDay00Z' },
  { labelKey: 'differenceRefPriorTradingDay06Z', value: 'PriorTradingDay06Z' },
  { labelKey: 'differenceRefPriorTradingDay12Z', value: 'PriorTradingDay12Z' },
  { labelKey: 'differenceRefPriorTradingDay18Z', value: 'PriorTradingDay18Z' },
];

export const DIFFERENCES_SELECTION_STORAGE_KEY = 'modelForecastDifferences';

export const DIFFERENCES_SECOND_SLOT_AUTO_OPENED_KEY =
  'modelForecastDifferencesSecondSlotAutoOpened';

export const DEFAULT_DIFFERENCES_SELECTION: DifferencesSelection = [
  { enabled: true, reference: 'TwelveHoursAgo' },
  { enabled: false, reference: 'TwelveHoursAgo' },
];

export const MAX_DIFFERENCE_SLOTS = 2;

export const DIFFERENCE_ROW_LABEL_PREFIX = 'Diff from';

export const DEFAULT_WIDGET_DIFFERENCES_SELECTION: DifferencesSelection = [
  { enabled: false, reference: 'TwelveHoursAgo' },
  { enabled: false, reference: 'TwelveHoursAgo' },
];
